import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories, webinarCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current(webinarCategories).require(basePlanCategories)];
  }

  async conflicts() {
    return [...webinarCategories.map(c=>[c])];
  }
}
